<template>
    <div class="match-detail">
        <div class="list">
            <div class="item">               
                <van-cell title-class="celltitle" title="状态" :value="item.title">
                    <template #default>
                        <van-button v-if="item.base_id == 0" type="primary" size="mini" @click="showPicker = true">关联赛事</van-button>
                        <span v-else>已关联</span>
                    </template>
                </van-cell>
                <van-cell v-if="item.base_id" title-class="celltitle" title="赛事编码" :value="item.number" />
                <van-cell title-class="celltitle" title="赛事名称" :value="item.title" />
                <van-cell title-class="celltitle" title="比赛项目" :value="item.project" />
                <van-cell title-class="celltitle" title="赛事板块" :value="item.match_plate" />
                <van-cell title-class="celltitle" title="赛事级别" :value="item.match_level" />
                <van-cell title-class="celltitle" title="比赛时间" :value="item.date" />
                <van-cell title-class="celltitle" title="调研地点" :value="item.address" />
                <van-cell title-class="celltitle" title="评估人员" :value="item.nickname" />
                <van-cell title-class="celltitle" title="同行人" :value="item.previous_checker" />
                <van-cell title-class="celltitle" title="评估信息">
                    <template #default>
                        <van-button type="primary" size="mini" @click="go(item)">查看信息</van-button>
                    </template>
                </van-cell>
                <!-- <van-cell title-class="celltitle" title="得分" :value="item.score" />
                <van-cell title-class="celltitle" title="评估电子签名">
                    <template #label>
                        <van-image
                            width="6.9rem"
                            height="2rem"
                            fit="contain"
                            :src="item.appraiser"
                        />
                    </template>
                </van-cell> -->
                <van-cell title-class="celltitle" title="负责人电子签名">
                    <template #label>
                        <van-image
                            width="6.9rem"
                            height="2rem"
                            fit="contain"
                            :src="item.principal"
                        />
                    </template>
                </van-cell>
            </div>
        </div>
        <div class="footer" v-if="item.status == 2">
            <van-button
            round
            @click="goto(item)"
            class="mvbutton"
            style="width: 100%;height:.8rem"
            >编辑</van-button>         
            <!-- <van-button
            type="default"
            round
            @click="gosubmit"
            class="mvbutton"
            style="width: 100%;height:.8rem"
            >提交</van-button>          -->
        </div>
        <van-popup v-model="show" position="bottom" closeable round :style="{ height: '80%',width: '100%',padding: '1rem 0 0 0' }">
            <van-cell-group >
                <template v-for="item in registerform" >
                    <van-cell size="mini" v-if="item.type==3" :title="item.show_name" :value="item.kvalue" />
                    <van-cell size="mini" v-else-if="item.type==1" :value="item.value" >
                        <template #title>
                            <span class="custom-title" v-html="item.show_name"></span>
                        </template>
                    </van-cell>                   
                    <van-cell size="mini" v-else-if="item.type==4" :title="item.show_name" :value="item.value" />                  
                    <van-cell size="mini" v-else-if="item.type==11" :title="item.show_name">
                        <template #default>
                            <span class="custom-title" @click="showimg(item.value)">点击查看</span>
                        </template>
                    </van-cell>
                    <van-cell size="mini" v-else :title="item.show_name">
                        <template #default>
                            <a :href="item.value" >点击下载</a>
                        </template>
                    </van-cell>
                </template>
                
            </van-cell-group>
            
        </van-popup>
        <van-popup v-model="showPicker" position="bottom" :style="{ height: '70%',width: '100%' }">
            <van-search
            v-model="keywords"
            show-action
            placeholder="请输入搜索关键词"
            @search="getmlist"
            >
                <template #action>
                    <div @click="getmlist">搜索</div>
                </template>
            </van-search>
            <van-picker
                show-toolbar
                :columns="columns"
                visible-item-count="10"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            />
        </van-popup>
    </div>
</template>

<script>
    import './index.less'
    import moment from 'moment';
    import { Swipe, SwipeItem, Tag,Cell, CellGroup,Image,Button,Popup,Picker,Search,ImagePreview  } from 'vant';
    export default {
        data() {
            return {
                show: false,
                item: {},
                registerform: [],
                showPicker: false,
                keywords: '',
                matchlist: [],
                columns: [],
                ishide: false
            }
        },
        components: {
            vanSwipe: Swipe,
            vanSwipeItem: SwipeItem,
            vanTag: Tag,
            VanCell: Cell,
            VanImage: Image,
            VanButton: Button,
            VanPopup: Popup,
            VanCellGroup: CellGroup,
            VanPicker: Picker,
            VanSearch: Search
        },
        methods: {
            showimg(value) {
                if(!value) return
                let arr = value.split(',')
                ImagePreview(arr)
            },
            goto(item) {
                let params = {
                    matchid: item.base_id,
                    evid: item.id
                }
                this.$router.push({name:'joinMatch',params})
            },
            gosubmit() {
                let query = {
                    status: 1,
                    id: this.$route.params.evid,
                }
                this.$api.match.editEnvState(query).then((res) => {
                    this.$toast.clear();
                    if (res.success) {
                        this.$toast.success('成功');
                        this.getlist()
                    }
                    
                })
            },
            onConfirm(value) {
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                });
                let item = this.matchlist.find(ele=>ele.match_name==value)
                let query = {
                    base_id: item.id,
                    id: this.$route.params.evid,
                }
                this.showPicker = false
                this.$api.match.editEnv(query).then((res) => {
                    this.$toast.clear();
                    if (res.success) {
                        this.$toast.success('成功');
                        this.showPicker = false
                        this.getlist()
                    }
                    
                })
            },
            go(item) {
                this.show = true
                let list = JSON.parse(item.registerform)
                this.ishide = false
                list.forEach((value, index) => {
                    if(!!value.value) {
                        if (value.type == 3) {
                            if (typeof value.options == "string")
                                value.options = JSON.parse(value.options);
                            let row = value.options.find(ele=>ele.key == value.value)
                            value.kvalue = row.value
                            if(value.value == 1) {
                                this.ishide = true
                            }
                        }
                        if (value.type == 4) {
                            // console.log(value.value)
                            // let value = JSON.parse(value.value);
                            value.value = value.value.toString()
                        }
                    }                       
                })
                this.registerform = list
                console.log(this.registerform)
            },
            getlist() {
               this.$api.match.getEnvDetail({evid:this.$route.params.evid}).then(res=>{
                    res.data.date = moment(res.data.start_time * 1000).format("YYYY/MM/DD");
                    this.item = res.data
               }) 
            },
            getmlist() {
                let query = {
                    page: 1,
                    keywords: this.keywords,
                    level: '市级',
                    'per-page': 50
                }
                this.$api.match.getlist(query).then(
                    (res) => {
                        let arr = []
                        res.data.list.forEach(item=>{
                            arr.push(item.match_name)
                        })
                        this.columns = arr
                        this.matchlist = res.data.list;
                    }
                );
            }
        },
        mounted() {
            this.getlist()
            this.getmlist()
        }
    }
</script>